import { render, staticRenderFns } from "./EditProject.page.vue?vue&type=template&id=6489ad7e&scoped=true&"
import script from "./EditProject.page.vue?vue&type=script&lang=js&"
export * from "./EditProject.page.vue?vue&type=script&lang=js&"
import style0 from "./EditProject.page.vue?vue&type=style&index=0&id=6489ad7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6489ad7e",
  null
  
)

export default component.exports